<div [innerHTML]="row?.status"></div>

<div class="textbox">
  <p class="text-{{row?.priority}} " *ngIf="row?.priority != 1">{{priorityEnum[row?.priority]}}</p>
</div>